/**
 * Recursively removes null and undefined values from an object and its nested structures
 * @param obj - The object to clean
 * @returns A new object with null and undefined values removed
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function cleanMetadata(obj: any): any {
  if (obj === null || obj === undefined) {
    return undefined;
  }

  if (Array.isArray(obj)) {
    // Filter out null/undefined from arrays and recursively clean remaining items
    return obj
      .filter(item => item !== null && item !== undefined)
      .map(item => cleanMetadata(item))
      .filter(item => item !== undefined);
  }

  if (typeof obj === 'object') {
    // For objects, recursively clean all properties
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cleaned: Record<string, any> = {};
    for (const [key, value] of Object.entries(obj)) {
      const cleanedValue = cleanMetadata(value);
      // Only add the property if the cleaned value is not undefined
      if (cleanedValue !== undefined) {
        cleaned[key] = cleanedValue;
      }
    }
    return cleaned;
  }

  // Return primitive values as-is
  return obj;
}